import { combineReducers } from 'redux'
import app from './app.js'

const reducer = combineReducers({
	app
})
export default reducer
